import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// Capturar URL inicial solo si es una URL de entrada válida
const currentUrl = window.location.href;
const existingUrl = localStorage.getItem('realInitialUrl');

// Solo guardar si no existe o si es una URL de entrada válida (raíz o vendedor)
const isEntryUrl = currentUrl.includes('/vendedor') || 
                  currentUrl.match(/\/$/) || 
                  currentUrl.includes('?desktop') ||
                  currentUrl.match(/\/\?.*desktop/);

if (!existingUrl || (isEntryUrl && !currentUrl.includes('/equipos') && !currentUrl.includes('/detalle-producto'))) {
  localStorage.setItem('realInitialUrl', currentUrl);
}

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
